/* eslint-disable no-unused-vars */

export const PricingUtils = {
  derivePrice,
  formattedNumber,
  formatPriceAfterRounding,
};

function derivePrice(
  decimal,
  cost,
  price,
  includeTax,
  taxPersentage,
  promotionIncludedInPrice,
  promotionPersentage,
  promotionAmt,
  isDiscounted,
  quantity,
  returnFlag,
  customDiscAmount,
  includePromOnFinalPrice
) {
  let netCost = parseFloat(cost) * parseFloat(quantity);
  let netPrice = parseFloat(price) * parseFloat(quantity);

  let result = derivePriceInternal(
    decimal,
    netCost,
    netPrice,
    includeTax,
    taxPersentage,
    promotionIncludedInPrice,
    promotionPersentage,
    promotionAmt,
    isDiscounted,
    1,
    returnFlag,
    customDiscAmount,
    includePromOnFinalPrice
  );

  result["price"] = formattedNumber(
    parseFloat(result["price"]) / parseFloat(quantity),
    decimal
  );
  result["taxAmount"] = formattedNumber(
    parseFloat(result["taxAmount"]) / parseFloat(quantity),
    decimal
  );
  result["priceExTax"] = formattedNumber(
    parseFloat(result["priceExTax"]) / parseFloat(quantity),
    decimal
  );
  result["promotionAmount"] = formattedNumber(
    parseFloat(result["promotionAmount"]) / parseFloat(quantity),
    decimal
  );
  result["retailSalePrice"] = formattedNumber(
    parseFloat(result["retailSalePrice"]) / parseFloat(quantity),
    decimal
  );

  return result;
}

function derivePriceInternal(
  decimal,
  cost,
  price,
  includeTax,
  taxPersentage,
  promotionIncludedInPrice,
  promotionPersentage,
  promotionAmt,
  isDiscounted,
  quantity,
  returnFlag,
  customDiscAmount,
  includePromOnFinalPrice
) {
  let result = {};

  if (!isDiscounted) {
    promotionPersentage = 0;
  }
  let retailSalePrice = parseFloat(price);

  let origPrice = retailSalePrice;
  let taxAmount = 0;
  let promotionAmount = 0;
  let promotionPer = promotionPersentage;

  if (price) {
    if (isDiscounted) {
      if (customDiscAmount) {
        if (includePromOnFinalPrice) {
          if (includeTax) {
            promotionPer = (customDiscAmount / retailSalePrice) * 100;
            retailSalePrice = retailSalePrice - customDiscAmount;
          } else {
            taxAmount = retailSalePrice * (taxPersentage / 100);
            retailSalePrice = retailSalePrice + taxAmount;
            promotionPer = (customDiscAmount / retailSalePrice) * 100;

            retailSalePrice = retailSalePrice - customDiscAmount;
          }
        } else {
          if (includeTax) {
            let origPrice1 = origPrice / (1 + taxPersentage / 100);
            promotionPer = (customDiscAmount / origPrice1) * 100;
            retailSalePrice = origPrice1 - customDiscAmount;
            retailSalePrice =
              retailSalePrice + retailSalePrice * (taxPersentage / 100);
          } else {
            promotionPer = (customDiscAmount / retailSalePrice) * 100;

            retailSalePrice = retailSalePrice - customDiscAmount;
          }
        }
      } else {
        //Normal Discount
        if (!promotionIncludedInPrice) {
          if (promotionPer > 0) {
            retailSalePrice =
              retailSalePrice - retailSalePrice * (promotionPer / 100);
          }
        }
        if (!includeTax) {
          if (taxPersentage > 0) {
            taxAmount = retailSalePrice * (taxPersentage / 100);
            retailSalePrice = retailSalePrice + taxAmount;
          }
        }
      }
    } else {
      if (!includeTax) {
        if (taxPersentage > 0) {
          taxAmount = retailSalePrice * (taxPersentage / 100);
          retailSalePrice = retailSalePrice + taxAmount;
        }
      }
    }
  }
  retailSalePrice = formattedNumber(retailSalePrice, decimal);

  if (taxPersentage > 0) {
    taxAmount = formattedNumber(
      parseFloat(retailSalePrice) -
        parseFloat(retailSalePrice) / (1 + taxPersentage / 100),
      decimal
    );
  } else {
    taxAmount = 0;
  }

  if (includeTax) {
    if (taxPersentage > 0) {
      origPrice = origPrice / (1 + taxPersentage / 100);
    }
  }
  origPrice = parseFloat(formattedNumber(origPrice, decimal));
  if (isDiscounted && !customDiscAmount) {
    if (promotionIncludedInPrice) {
      if (promotionPer) {
        origPrice = origPrice / (1 - promotionPer / 100);
      }
    }
  }
  origPrice = formattedNumber(origPrice, decimal);

  if (isDiscounted) {
    if (!customDiscAmount) {
      if (promotionPer > 0)
        promotionAmount = formattedNumber(
          parseFloat(origPrice) * (promotionPer / 100),
          decimal
        );
    } else {
      promotionAmount = customDiscAmount;
    }
  } else {
    promotionAmount = "0";
  }

  let margin = formattedNumber(
    parseFloat(retailSalePrice) - parseFloat(taxAmount) - parseFloat(cost),
    decimal
  );
  result["cost"] = formattedNumber(cost, decimal);
  result["price"] = origPrice;
  result["retailSalePrice"] = retailSalePrice;
  result["taxAmount"] = taxAmount;
  result["taxPersentage"] = taxPersentage;
  result["promotionAmount"] = promotionAmount;
  result["promotionPersentage"] = formattedNumber(promotionPer, decimal);
  result["margin"] = margin;
  result["quantity"] = quantity;
  result["priceExTax"] = formattedNumber(parseFloat(origPrice), decimal);
  result["netAmount"] = formattedNumber(
    parseFloat(retailSalePrice) * quantity * (returnFlag ? -1 : 1),
    decimal
  );

  if (taxPersentage > 0) {
    let netTax = formattedNumber(
      parseFloat(result["netAmount"]) -
        parseFloat(result["netAmount"]) / (1 + taxPersentage / 100),
      decimal
    );
    result["netTax"] = netTax;
  } else {
    result["netTax"] = formattedNumber(0, decimal);
  }

  result["netCost"] = formattedNumber(
    parseFloat(result["cost"]) * quantity,
    decimal
  );
  result["netMargin"] = formattedNumber(
    parseFloat(result["margin"]) * quantity * (returnFlag ? -1 : 1),
    decimal
  );

  let marginPer = formattedNumber(
    parseFloat(
      result["netMargin"] /
        (parseFloat(result["netAmount"]) - parseFloat(result["netTax"]))
    ) * 100,
    decimal
  );
  result["marginPer"] = marginPer;

  return result;
}
/*
function derivePromotionPersentage(promotions, ignoreDate, qty) {
  let persentatge = 0;
  let label = "";
  let promotionId = "";
  if (promotions) {
    for (let promo of promotions) {
      if (parseFloat(promo.ruleBuyLimit) <= qty) {
        if (!ignoreDate) {
          if (isValidDate(promo)) {
            let per = parseFloat(promo.promotionPercentage);
            if (per > persentatge) persentatge = per;
          }
        } else {
          let today = new Date();
          let fromDate = new Date(promo.fromDate);
          let toDate = new Date(promo.toDate);
          if (fromDate <= today && today <= toDate) {
            let per = parseFloat(promo.promotionPercentage);
            if (per > persentatge) persentatge = per;
          }
        }
      }
    }
  }
  return persentatge;
}*/

function formattedNumber(inputString, decimal) {
  let val = parseFloat(inputString).toFixed(decimal);
  return val;
}

function formatPriceAfterRounding(
  inputString,
  decimal,
  enableRoundoffSaleAmount,
  roundOffFactor
) {
  try {
    if (enableRoundoffSaleAmount) {
      let val = parseFloat(parseFloat(inputString).toFixed(decimal));
      var inv = 1.0 / (roundOffFactor ? parseFloat(roundOffFactor) : 1);
      val = Math.round(val * inv) / inv;
      val = val.toFixed(decimal);
      return val;
    } else {
      let val = parseFloat(inputString).toFixed(decimal);
      return val;
    }
  } catch (ex) {
    console.log("ERROR", ex);
    return inputString;
  }
}
